import {StyleSheet} from 'react-native';
import CommonStyles from '../../utils/CommonStyles';

// Theme-aware styles factory (the makeStyles pattern — docs/DARK-MODE.md):
// consumed via useThemedStyles(makeStyles) so colors re-resolve on theme
// change instead of baking at module load. Style-as-function entries are
// preserved — the factory returns them closed over the theme's colors.
const makeStyles = colors =>
  StyleSheet.create({
    mainView: {
      ...CommonStyles.half_min_width,
      ...CommonStyles.full_flex,
      backgroundColor: colors.background,
    },
    formView: {
      paddingBottom: 120,
      ...CommonStyles.ph_56,
      ...CommonStyles.full_flex,
    },
    backIcon: {
      width: 5,
      height: 9,
    },
    signinRouteContainer: {
      ...CommonStyles.flex_row,
      ...CommonStyles.items_center,
      ...CommonStyles.mb_32,
    },
    leftInput: isDesktop => ({
      ...CommonStyles.full_flex,
      ...CommonStyles.max_width_292,
      ...(isDesktop && {...CommonStyles.mr_12}),
    }),
    rightInput: isDesktop => ({
      ...CommonStyles.full_flex,
      ...CommonStyles.max_width_292,
      ...(isDesktop ? {...CommonStyles.ml_12} : CommonStyles.mt_16),
    }),
    buttonContainer: {
      backgroundColor: colors.surface,
      ...CommonStyles.flex_row,
      ...CommonStyles.justify_center,
      ...CommonStyles.pv_24,
      ...CommonStyles.ph_56,
      ...CommonStyles.absolute_pos,
      ...CommonStyles.b_0,
      ...CommonStyles.r_0,
      ...CommonStyles.l_0,
      borderTopWidth: 1,
      borderColor: colors.borderMuted,
      borderTopLeftRadius: 16,
      borderTopRightRadius: 16,
    },
    nextButton: {
      ...CommonStyles.full_flex,
      ...CommonStyles.ml_12,
      ...CommonStyles.max_width_292,
    },
    cancelButton: {
      ...CommonStyles.full_flex,
      ...CommonStyles.mr_12,
      ...CommonStyles.max_width_292,
    },
    marginLeftMinus4: {
      marginLeft: -4,
    },
    marginTopMinus4: {
      marginTop: -4,
    },
    checkbox: {
      width: 17,
      height: 17,
    },
    logo: {
      width: 146,
      height: 40,
      marginVertical: 40,
    },
  });

export default makeStyles;
